"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var ComponentWithFormRowWrapper_1 = require("../../utils/hoc/ComponentWithFormRowWrapper");
var Select_1 = require("../Select");
var propTypes = __assign({}, ComponentWithFormRowWrapper_1.withFormRowWrapperPropTypes, { children: PropTypes.any });
// TODO: make defaultProps show up in styleguidist
// it seems the parser can't handle the HOC
var defaultProps = {
    label: undefined,
    description: undefined,
    tooltip: undefined,
    error: false,
    children: undefined
};
/**
 * The `SelectRow` component is a shortcut for a `Select` component wrapped in
 * a `FormRow` component.
 *
 * All additional class names will be passed down to the `FormRow` component and
 * can be defined by the `className` prop. All other props will be passed
 * down to the `Select` component.
 *
 * <div class="box box--ux">
 *  <p>
 *    A <code>Select</code> component should always contain at least four options.
 *    For fewer options use a
 *    <a href="#!/RadioGroupRow">RadioGroupRow</a> instead.
 *  </p>
 * </div>
 */
exports.SelectRow = ComponentWithFormRowWrapper_1.withFormRowWrapper(propTypes, defaultProps, ComponentWithFormRowWrapper_1.withFormRowWrapperSplitProps)(Select_1.Select);
exports.SelectRow.displayName = 'SelectRow';
exports.default = exports.SelectRow;
//# sourceMappingURL=SelectRow.js.map
